export const darkTheme = {
    palette: {
        primary: {
            main: '#90caf9',
        },
        secondary: {
            main: '#FBBA72',
        },
        type: 'dark' as 'dark', // Switching the dark mode on is a single property value change.
    },
    overrides: {

    },
};

export const lightTheme = {
    palette: {
        primary: {
            main: '#000',
            dark: '#111111',
            light: '#fff'
        },
        secondary: {
            light: '#5f5fc4',
            main: '#1a1a1a',
            dark: '#001064',
            contrastText: '#fff',
        },
        background: {
            default: '#fff',
        },
        type: 'light' as 'light',
    },
    typography: {
        fontFamily: 'NettoOT',
    },
    shape: {
        borderRadius: 10,
    },
    overrides: {
        RaDatagrid: {
            headerCell: {
                backgroundColor: '#000',
                color: '#fff'
            }
        },
        RaMenuItemLink: {
            root: {
                borderLeft: '3px solid #fff',
            },
            active: {
                borderLeft: '3px solid #4f3cc9',
            },
        },
        MuiPaper: {
            elevation1: {
                boxShadow: 'none',
            },
            root: {
                border: '1px solid #e0e0e3',
                backgroundClip: 'padding-box',
            },
        },
        MuiButton: {
            contained: {
                backgroundColor: '#000',
                color: '#fff'
            },
        },
        MuiAppBar: {
            colorSecondary: {
                color: '#808080',
                backgroundColor: '#fff',
            },
        },
        MuiLinearProgress: {
            colorPrimary: {
                backgroundColor: '#f5f5f5',
            },
            barColorPrimary: {
                backgroundColor: '#d7d7d7',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        RaLayout: {
            root: {
                marginTop: 0
            }
        },
        RaFilterButton: {
            root: {
                paddingTop: '0px !important'
            }
        },
        RaButton: {
            button: {
                alignItems: 'flex-start'
            }
        },
        MuiTableSortLabel: {
            root: {
                "&:hover": {
                    color: "#fff"
                }
            }
        }
    },
};
